import React, { Component, Fragment, useEffect, useState } from "react";
import {
    Row, Card,
    CardTitle, Label,
    Input, Button,
    FormGroup, Modal,
    ModalBody, InputGroup,
    InputGroupAddon,
    InputGroupText,
    Col,
} from 'reactstrap';
import { Colxx } from "../../../../../../../components/common/CustomBootstrap";
import { components } from "react-select";
import StepWizard, { Step } from 'react-step-wizard'; // Import Step explicitly
import { default as ReactSelect } from "react-select";
import { NotificationManager } from "../../../../../../../components/common/react-notifications";
import { postAPI_Invitation, postAPI_EmailCheck, gAPI_Internal_Property_By_Id } from "../../../../../../../constants/APIs";
import { AxiosAPI, getGroupID } from "../../../../../../../helpers/AxiosAPI";

export default function SellVoucher({ toggle, isvisible, propertyId, userData, propertydata, voucherList, locale }) {
    const [widthDiv, setwidthDiv] = useState('95%');
    const [bottomNavHidden, setBottomNavHidden] = useState(true);
    const [optionSelected, setOptionSelected] = useState([]);
    const [propertyData, setPropertyData] = useState(propertydata);
    const [showVoucher, setShowVoucher] = useState('Please Select');
    let options = [];
    let [inviteeData, setInviteeData] = useState({
        "groupId": getGroupID(),
        "senderName": propertyData.name,
        "senderEmail": userData.email ? userData.email : '',
        "inviteeEmail": '',
        "senderGroupId": getGroupID(),
        "senderPpropertyId": propertyId,
        "invitationStatus": 'Invited',
        "processingFee": '',
        "sellFutureVouchers": 'false',
        "status": 'Active',
        "createdBy": 'Admin',
        "type": 'Sell',
        'EmailType': '',
        "voucherList": [{
            'VoucherId': '',
            'ProcessingFee': '',
            'status': 'Active'
        }]
    });

    const SendInviation = () => {
        if (!bottomNavHidden) {
            AxiosAPI({
                method: 'post',
                url: `${postAPI_EmailCheck}`,
                data: {
                    email: propertyData.email,
                },
            })
                .then((res) => {
                    if (res.data.exists) {
                        inviteeData.EmailType = 'Multiple';
                    }
                    AxiosAPI({
                        url: `${postAPI_Invitation}`,
                        method: 'post',
                        data: inviteeData
                    }).then(res => {
                        if (res.data.status !== 'Failed') {
                            NotificationManager.success(
                                "",
                                "Invitation sent successfully",
                                3000,
                                null,
                                null,
                                "success"
                            );
                        } else {
                            NotificationManager.success(
                                "",
                                "Something went wrong",
                                3000,
                                null,
                                null,
                                "danger"
                            );
                        }
                    }).catch();
                })
                .catch((err) => null);
        }
    };

    const handleChange = async (selected) => {
        if (selected.length > 0) {
            selected.map((s) => {
                if (optionSelected.filter((f) => f.value === s.value).length > 0) {
                    let list = optionSelected.filter((f) => f.value !== s.value);
                    setOptionSelected(list);
                } else {
                    let list = optionSelected;
                    list.push({ value: s.value, label: s.label, isSelected: true });
                    setOptionSelected(list);
                }
            })
        } else {
            setOptionSelected([]);
        }
    };

    const onClickNext = (nextStep, steps, currentStep) => {
        if (currentStep === 1)
            LoadData();
        if (steps === 5) {
            return;
        }
        if (currentStep === 4) {
            let list = [];
            setBottomNavHidden(false);
            optionSelected.map((o) => {
                voucherList.map((v) => {
                    if (showVoucher === 'Yes') {
                        if (o.value === v.id) {
                            list.push({
                                'VoucherId': v.id,
                                'ProcessingFee': v.processingFee,
                                'status': v.status
                            });
                        }
                    }
                })
            });
            setInviteeData({ ...inviteeData, voucherList: list });
        }
        nextStep();
    };

    const onClickPrev = (previousStep, steps, currentStep) => {
        setwidthDiv('95%');
        if (currentStep === 1) {
            return;
        }
        previousStep();
    };

    const Option = (props) => {
        return (
            <div>
                <components.Option {...props}>
                    <input
                        type="checkbox"
                        checked={optionSelected.filter((f) => f.value === props.value).length > 0 ? true : false}
                        onChange={() => setInviteeData({ ...inviteeData, voucherList: [] })}
                    />{" "}
                    <label>{props.label}</label>
                </components.Option>
            </div>
        );
    };

    const LoadData = () => {
    };

    const voucherDropDownChange = (e) => {
        setShowVoucher(e.target.value);
    };

    const NavigationButtons = ({ nextStep, previousStep, currentStep, totalSteps }) => (
        bottomNavHidden && (
            <div className="mt-4 d-flex justify-content-center">
                <Button
                    color="secondary"
                    onClick={() => onClickPrev(previousStep, totalSteps, currentStep)}
                    disabled={currentStep === 1}
                    className="mr-2"
                >
                    Back
                </Button>
                <Button
                    color="primary"
                    onClick={() => onClickNext(nextStep, totalSteps, currentStep)}
                    disabled={currentStep === totalSteps}
                >
                    Next
                </Button>
            </div>
        )
    );

    return (
        <Fragment>
            <Modal
                toggle={toggle}
                size="lg"
                isOpen={isvisible}
                style={{ maxWidth: '50%' }}
            >
                <ModalBody toggle={toggle}>
                    <Row className="h-100">
                        <Colxx xxs="12" className="mx-auto my-auto">
                            <Card className="auth-card">
                                <div
                                    className="form-side wizard wizard-default"
                                    style={{ padding: '20px', margin: 'auto', width: widthDiv }}
                                >
                                    <div style={{ textAlign: 'center' }}>
                                        <Row className="row my-3 text-right">
                                            <Colxx sm={8} className="mb-3">
                                                <h3>Invite a 3<span>rd</span> party to sell their voucher</h3>
                                            </Colxx>
                                            <Colxx sm={4} className="mb-3" onClick={() => { toggle(); SendInviation(); }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-x" viewBox="0 16 16">
                                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                                </svg>
                                            </Colxx>
                                        </Row>
                                    </div>
                                    <StepWizard>
                                        <Step stepName="step1">
                                            {({ nextStep, previousStep, currentStep, totalSteps }) => (
                                                <div>
                                                    <FormGroup>
                                                        <CardTitle className="text-center">
                                                            <p className='my-2'>Aiva make it easy to expand your footprint. Aiva enables you to invite 3rd parties to sell your Vouchers from their websites and physical locations.</p>
                                                            <p className='my-2'>A commission can be defined for each Voucher, and all payouts are calculated and distributed instantly by Aiva.</p>
                                                            <p className='voucher-preview my-2'><a target="blank" href='https://www.bookmebob.com/vouchers'> Learn more...</a></p>
                                                            <p className='my-2 mb-4'>
                                                                Myma.ai processing fee includes the credit card transaction fee that we directly pay out
                                                                to the Credit Card processor. Add a %age commission you want to share with the 3rd party for
                                                                the voucher sale. You can later go and adjust the fee at each Voucher level.
                                                            </p>
                                                        </CardTitle>
                                                    </FormGroup>
                                                    <NavigationButtons
                                                        nextStep={nextStep}
                                                        previousStep={previousStep}
                                                        currentStep={currentStep}
                                                        totalSteps={totalSteps}
                                                    />
                                                </div>
                                            )}
                                        </Step>
                                        <Step stepName="step2">
                                            {({ nextStep, previousStep, currentStep, totalSteps }) => (
                                                <div>
                                                    <p className="text-center my-4">
                                                        Do you want to sell selected vouchers with the 3rd party or all ?
                                                    </p>
                                                    <Row>
                                                        <Col className="col-md-4 mx-3">
                                                            <Input
                                                                type="select"
                                                                value={showVoucher}
                                                                name="status"
                                                                onChange={voucherDropDownChange}
                                                            >
                                                                <option value="Please Select">Please Select</option>
                                                                <option value="Yes">Yes</option>
                                                                <option value="No">No</option>
                                                            </Input>
                                                        </Col>
                                                        <Col className="col-md-6 mx-3" style={{ width: "250px" }}>
                                                            {voucherList.map((m) => {
                                                                if (!m.thirdPartyVoucher)
                                                                    options.push({ value: m.id, label: m.name });
                                                            })}
                                                            {voucherList !== undefined && voucherList.length > 0 && showVoucher === 'Yes' && <ReactSelect
                                                                options={options}
                                                                isMulti
                                                                closeMenuOnSelect={false}
                                                                components={{ Option }}
                                                                placeholder='Please select voucher'
                                                                onChange={handleChange}
                                                                allowSelectAll={true}
                                                                value={optionSelected}
                                                            />}
                                                        </Col>
                                                    </Row>
                                                    <NavigationButtons
                                                        nextStep={nextStep}
                                                        previousStep={previousStep}
                                                        currentStep={currentStep}
                                                        totalSteps={totalSteps}
                                                    />
                                                </div>
                                            )}
                                        </Step>
                                        <Step stepName="step3">
                                            {({ nextStep, previousStep, currentStep, totalSteps }) => (
                                                <div>
                                                    <p className="text-center my-4">
                                                        Myma.ai processing fee includes the credit card transaction fee that we directly
                                                        pay out to the credit card processs. Add the commission that you want to propose to the 3rd party
                                                        for vouchers selled by you.
                                                    </p>
                                                    <Row>
                                                        <Colxx sm={6} className="mb-3">
                                                            <FormGroup>
                                                                <Label>Myma.ai Processing Fee</Label>
                                                                <InputGroup>
                                                                    <Input
                                                                        type="number"
                                                                        name="bmbVoucherProcessingFee"
                                                                        id="bmbVoucherProcessingFee"
                                                                        disabled={true}
                                                                        value={propertyData.bmbVoucherProcessingFee}
                                                                    />
                                                                    <InputGroupAddon>
                                                                        <InputGroupText>%</InputGroupText>
                                                                    </InputGroupAddon>
                                                                </InputGroup>
                                                            </FormGroup>
                                                        </Colxx>
                                                        <Colxx sm={6} className="mb-3">
                                                            <FormGroup>
                                                                <Label>Add Your Commission</Label>
                                                                <InputGroup>
                                                                    <Input
                                                                        type="number"
                                                                        name="processingFee"
                                                                        id="processingFee"
                                                                        value={inviteeData.processingFee}
                                                                        onChange={(e) => {
                                                                            setInviteeData({ ...inviteeData, processingFee: e.target.value });
                                                                        }}
                                                                    />
                                                                    <InputGroupAddon>
                                                                        <InputGroupText>%</InputGroupText>
                                                                    </InputGroupAddon>
                                                                </InputGroup>
                                                            </FormGroup>
                                                        </Colxx>
                                                    </Row>
                                                    <NavigationButtons
                                                        nextStep={nextStep}
                                                        previousStep={previousStep}
                                                        currentStep={currentStep}
                                                        totalSteps={totalSteps}
                                                    />
                                                </div>
                                            )}
                                        </Step>
                                        <Step stepName="step4">
                                            {({ nextStep, previousStep, currentStep, totalSteps }) => (
                                                <div>
                                                    <p className="text-center my-4">
                                                        What is their email address? We’ll notify them and ask for them to approve your request.
                                                        Once approved, your vouchers will start showing on their Online Voucher Store.
                                                    </p>
                                                    <Row className="mx-auto">
                                                        <Colxx sm={6} className="mx-auto">
                                                            <FormGroup>
                                                                <InputGroup>
                                                                    <InputGroupAddon>
                                                                        <InputGroupText>From</InputGroupText>
                                                                    </InputGroupAddon>
                                                                    <Input
                                                                        type="text"
                                                                        name="senderName"
                                                                        id="senderName"
                                                                        placeholder=''
                                                                        value={inviteeData.senderName}
                                                                        onChange={(e) => {
                                                                            setInviteeData({ ...inviteeData, senderName: e.target.value });
                                                                        }}
                                                                    />
                                                                </InputGroup>
                                                            </FormGroup>
                                                        </Colxx>
                                                        <Colxx sm={6} className="mx-auto">
                                                            <FormGroup>
                                                                <InputGroup>
                                                                    <InputGroupAddon>
                                                                        <InputGroupText>@</InputGroupText>
                                                                    </InputGroupAddon>
                                                                    <Input
                                                                        type="text"
                                                                        name="inviteeEmail"
                                                                        id="inviteeEmail"
                                                                        placeholder='Their Email Address'
                                                                        value={inviteeData.inviteeEmail}
                                                                        onChange={(e) => {
                                                                            setInviteeData({ ...inviteeData, inviteeEmail: e.target.value });
                                                                        }}
                                                                    />
                                                                </InputGroup>
                                                            </FormGroup>
                                                        </Colxx>
                                                    </Row>
                                                    <NavigationButtons
                                                        nextStep={nextStep}
                                                        previousStep={previousStep}
                                                        currentStep={currentStep}
                                                        totalSteps={totalSteps}
                                                    />
                                                </div>
                                            )}
                                        </Step>
                                        <Step stepName="step5">
                                            {({ nextStep, previousStep, currentStep, totalSteps }) => (
                                                <div>
                                                    <CardTitle className="text-center">
                                                        <p>Awesome, all done from your side!</p>
                                                        <p className="my-2">
                                                            The 3rd party has been notified on email. We’ll send you an update when they have accepted your invitation to sell.
                                                        </p>
                                                    </CardTitle>
                                                    <Row className="row my-3 text-center">
                                                        <Colxx sm={12} className="text-center mb-3">
                                                            <Button color='primary' onClick={() => { toggle(); SendInviation(); }}>
                                                                Close
                                                            </Button>
                                                        </Colxx>
                                                    </Row>
                                                </div>
                                            )}
                                        </Step>
                                    </StepWizard>
                                </div>
                            </Card>
                        </Colxx>
                    </Row>
                </ModalBody>
            </Modal>
        </Fragment>
    );
}